import {
  Subscription,
  SubscriptionType,
} from '../../../../core/models/subscription/subscription.model';
import { BaseService } from '../../../../core/services/base.service';

export interface SubscriptionHashCodeResponse {
  createdDate: string;
  createdBy: string;
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  subCategories: string[];
  lastNotificationDate: string;
  fullname: string;
}

export class SubscriptionService {
  static async AddSubscription(
    subscription: Subscription
  ): Promise<Subscription> {
    try {
      const url = BaseService.BuildUrl(`/public/subscribers`);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName: subscription.firstName,
          lastName: subscription.lastName,
          email: subscription.email,
          subCategories: subscription.subCategories,
          subscriptions: [
            {
              subscriptionType: SubscriptionType.EMAIL,
              value: subscription.email,
            },
          ],
        }),
      });

      let data = await response.json();

      if (!response.ok) {
        if ([401, 404].includes(response.status)) {
          throw new Error(`SHOW: Subscription error`);
        }

        throw new Error(`${response.status} - ${data.message}`);
      }

      return data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }

  static async CheckSubscriptionHashCode(
    hashCode: string | null
  ): Promise<SubscriptionHashCodeResponse> {
    try {
      const url = BaseService.BuildUrl(
        `/public/subscribers/codes/{code}?code=${hashCode}`
      );

      const response = await fetch(url, {
        method: 'GET',
      });

      let data = await response.json();

      if (!response.ok) {
        if ([401, 404].includes(response.status)) {
          throw new Error(`SHOW: Hash code not valid`);
        }

        throw new Error(`${response.status} - Hash code not valid`);
      }

      return data;
    } catch (error: any) {
      throw new Error(`${error.message}`);
    }
  }
}
